import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import CircleIcon from "@mui/icons-material/Circle";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import CancelIcon from "@mui/icons-material/Cancel";

import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";

import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  MenuItem,
  Select,
  TextField,
  Chip,
  Tooltip,
  Checkbox,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import StopCircleIcon from "@mui/icons-material/StopCircle";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import UpdateIcon from "@mui/icons-material/Update";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Accounts() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const accessToken = sessionStorage.getItem("accessToken");
  let isAdmin = useSelector((state) => state.admin.value);
  let username = useSelector((state) => state.user.value);
  let isMember = useSelector((state) => state.member.value);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [loadingRows, setLoadingRows] = useState({});
  const [showStartConfirm, setShowStartConfirm] = useState(false);
  const [showStopConfirm, setShowStopConfirm] = useState(false);
  const [showChangeSchedule, setShowChangeSchedule] = useState(false);
  const [accountDetails, setAccountDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Statusloading, setStatusLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [zone, setZone] = useState("");

  const [isWeekendRunEnabled, setIsWeekendRunEnabled] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsWeekendRunEnabled(event.target.checked);
  };

  const [error, setError] = useState(false);
  const getaccounts = () => {
    return axios
      .get(`${apiUrl}/accounts`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      })
      .then((response) => {
        setLoading(false);
        setAccountDetails(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const dayLabels = {
    1: "Sunday",
    2: "Monday",
    3: "Tuesday",
    4: "Wednesday",
    5: "Thursday",
    6: "Friday",
    7: "Saturday",
  };
  const [days, setDays] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const [accountDataSchedule, setAccountDataSchedule] = useState({});

  function generateCronExpressions(days, startTime, endTime) {
    /**
     * @param {string} time - Time in "HH:mm" format.
     * @returns {Object} - An object containing hours and minutes.
     */
    const parseTime = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      return { hours, minutes };
    };
    /**
     * @param {number} hours - Hours component of the time.
     * @param {number} minutes - Minutes component of the time.
     * @returns {Object} - An object containing adjusted hours and minutes.
     */
    const subtract30Minutes = (hours, minutes) => {
      const totalMinutes = hours * 60 + minutes - 30;
      const adjustedHours = Math.floor(((totalMinutes + 1440) % 1440) / 60);
      const adjustedMinutes = ((totalMinutes + 1440) % 1440) % 60;
      return { hours: adjustedHours, minutes: adjustedMinutes };
    };
    const { hours: startHour, minutes: startMinute } = parseTime(startTime);
    const { hours: endHour, minutes: endMinute } = parseTime(endTime);
    const { hours: halfHourBeforeHour, minutes: halfHourBeforeMinute } =
      subtract30Minutes(startHour, startMinute);
    const daysString = days.join(",");
    const filteredDays = days.filter((day) => day !== "1" && day !== "7");
    const filteredDaysString = filteredDays.join(",");
    const startCron = `${startMinute} ${startHour} ? * ${daysString} *`;
    let endCron;
    if (isWeekendRunEnabled) {
      endCron = `${endMinute} ${endHour} ? * ${daysString} *`;
    } else {
      endCron = `${endMinute} ${endHour} ? * ${filteredDaysString},1,7 *`;
    }
    const halfHourBeforeCron = `${halfHourBeforeMinute} ${halfHourBeforeHour} ? * ${daysString} *`;
    return {
      startCron,
      endCron,
      halfHourBeforeCron,
    };
  }

  useEffect(() => {
    getaccounts();
  }, []);

  const handleStartClick = () => {
    setShowStartConfirm(true);
  };

  const handleStopClick = () => {
    setShowStopConfirm(true);
  };

  const numberToDays = {
    1: "Sun",
    2: "Mon",
    3: "Tue",
    4: "Wed",
    5: "Thu",
    6: "Fri",
    7: "Sat",
  };

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#1890ff",
          ...theme.applyStyles("dark", {
            backgroundColor: "#177ddc",
          }),
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "rgba(0,0,0,.25)",
      boxSizing: "border-box",
      ...theme.applyStyles("dark", {
        backgroundColor: "rgba(255,255,255,.35)",
      }),
    },
  }));

  const [isEnabled, setIsEnabled] = useState(true);

  const handleToggle = (event) => {
    setIsEnabled(event.target.checked);
  };
  const handleChangeScheduleConfirm = (e) => {
    e.preventDefault();
    if (isEnabled) {
      if (startTime === "" || endTime === "" || days.length === 0) {
        alert("Fill in all the details");
        return;
      }
    }

    const scheduleObj = isEnabled
      ? {
          scheduledescription: `${days.map((i) => {
            return numberToDays[i];
          })} Stops:${endTime} Starts:${startTime}`,
          startecscronexpression: generateCronExpressions(
            days,
            startTime,
            endTime
          ).startCron,
          startrdscronexpression: generateCronExpressions(
            days,
            startTime,
            endTime
          ).halfHourBeforeCron,
          stopcronexpression: generateCronExpressions(days, startTime, endTime)
            .endCron,
          timezone: zone,
          state: "ENABLED",
          AccountName: accountDataSchedule.name,
          AccountNo: accountDataSchedule.number,
          id: accountDataSchedule.id,
          username: username,
        }
      : {
          scheduledescription: `Disabled`,
          startecscronexpression: "30 8 ? * 1,3,5 *",
          startrdscronexpression: "00 8 ? * 1,2,3,4,5 *",
          stopcronexpression: "0 0 ? * * *",
          timezone: "Asia/Calcutta",
          state: "DISABLED",
          AccountName: accountDataSchedule.name,
          AccountNo: accountDataSchedule.number,
          id: accountDataSchedule.id,
          username: username,
        };
    axios
      .post(`${apiUrl}/schedule`, scheduleObj, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      })
      .then((response) => {
        // console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
    // console.log(scheduleObj);
    setShowChangeSchedule(false);
    setAccountDataSchedule({});
    setIsWeekendRunEnabled(false);
    setDays([]);
    setZone("");
    setEndTime("");
    setStartTime("");
  };

  const handleStartConfirm = () => {
    let selectedAccountNos = [];
    let selectedAccountNames = [];
    selectedAccounts.forEach((obj) => {
      selectedAccountNos.push(obj.AccountNo);
      selectedAccountNames.push(obj.AccountName);
    });

    const jsonAccountIds = {
      accountnames: selectedAccountNames,
      username: username,
      accountNos: selectedAccountNos,
    };
    axios
      .post(`${apiUrl}/start`, jsonAccountIds, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      })
      .then((response) => {
        setOpen(true);
        setMessage(response.data.message);
        setError(false);
      })
      .catch((error) => {
        setOpen(true);
        setMessage(error);
        setError(true);
      });
    setShowStartConfirm(false);
    setSelectedAccounts([]);
  };
  const handleStatus = async () => {
    setStatusLoading(true);
    try {
      await getaccounts();
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setStatusLoading(false);
    }
  };

  const handleStopConfirm = () => {
    let selectedAccountNos = [];
    let selectedAccountNames = [];
    selectedAccounts.forEach((obj) => {
      selectedAccountNos.push(obj.AccountNo);
      selectedAccountNames.push(obj.AccountName);
    });
    const jsonAccountIds = {
      accountnames: selectedAccountNames,
      username: username,
      accountNos: selectedAccountNos,
    };
    axios
      .post(`${apiUrl}/stop`, jsonAccountIds, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      })
      .then((response) => {
        setOpen(true);
        setMessage(response.data.message);
        setError(false);
      })
      .catch((error) => {
        setOpen(true);
        setMessage(error);
        setError(true);
      });
    setShowStopConfirm(false);
    setSelectedAccounts([]);
  };

  const handleCancelChange = () => {
    setDays([]);
    setEndTime("");
    setStartTime("");
    setZone("");
    setAccountDataSchedule({});
    setIsWeekendRunEnabled(false);
    setShowChangeSchedule(false);
  };

  const handleCancel = () => {
    setShowStartConfirm(false);
    setShowStopConfirm(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleRefresh = (row) => {
    setLoadingRows((prev) => ({ ...prev, [row.id]: true }));

    axios
      .post(`${apiUrl}/monitoring`, row, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      })
      .then((response) => {
        console.log("Response data:", response.data);
        setAccountDetails((prevDetails) =>
          prevDetails.map((item) =>
            item.id === row.id ? { ...item, ...response.data } : item
          )
        );
      })
      .catch((error) => {
        console.error("Error updating account:", error);
      })
      .finally(() => {
        setLoadingRows((prev) => ({ ...prev, [row.id]: false }));
      });
  };
  const columns = [
    {
      field: "AccountName",
      headerName: "Account Name",
      // width: 240,
      flex: 1.3,
      headerClassName: "bg-customBlue text-white ",
    },
    {
      field: "AccountNo",
      headerName: "Account Number",
      // width: 200,
      flex: 1,
      headerClassName: "bg-customBlue text-white",
    },
    {
      field: "Status",
      headerName: "Status",
      // width: 180,
      flex: 0.7,
      sortable: false,
      headerClassName: "bg-customBlue text-white",
      renderCell: (params) => (
        <>
          {params.value === "Stopped" ? (
            <>
              <CircleIcon sx={{ color: "#ff3333", marginRight: "4px" }} />
              Stopped
            </>
          ) : (
            <>
              <CircleIcon sx={{ color: "#4BB543", marginRight: "4px" }} />
              Running
            </>
          )}
        </>
      ),
    },
    {
      field: "LastUpdatedStatus",
      headerName: "Last Refreshed on",
      // width: 180,
      flex: 1,
      sortable: false,
      headerClassName: "bg-customBlue text-white",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span>{params.value || "Unknown"}</span>
          <button
            onClick={(event) => {
              event.stopPropagation();
              handleRefresh(params.row);
            }}
            disabled={loadingRows[params.row.id]} // Disable button while loading
          >
            {loadingRows[params.row.id] ? (
              <CircularProgress size={18} />
            ) : (
              <RefreshIcon size={16} />
            )}
          </button>
        </div>
      ),
    },
    {
      field: "OpenApp",
      headerName: "Open Portal",
      headerClassName: "bg-customBlue text-white ",
      // width: 240,
      flex: 0.7,
      renderCell: (params) => (
        <a href={params.value} target="_blank" rel="noopener noreferrer">
          {params.value ? (
            <>
              <span style={{ marginRight: "2px" }}>Portal</span>{" "}
              <OpenInNewIcon />
            </>
          ) : (
            "No Link Available"
          )}
        </a>
      ),
      sortable: false,
    },
    {
      field: "Schedule",
      headerName: "Schedule",
      renderCell: (params) => (
        <>
          <button
            onClick={(event) => {
              setShowChangeSchedule(true);
              setAccountDataSchedule({
                number: params.row.AccountNo,
                name: params.row.AccountName,
                id: params.row.id,
              });
              setIsEnabled(params.value == "Disabled" ? false : true);
            }}
          >
            <Tooltip title="Edit Schedule" arrow>
              <EditCalendarIcon style={{ cursor: "pointer" }} />
            </Tooltip>
          </button>
          <span style={{ marginRight: "10px" }}>
            <Tooltip title={`${params.value} : ${params.row.timezone}`} arrow>
              <span>{params.value || "Unknown"}</span>
            </Tooltip>
          </span>
        </>
      ),
      flex: 2.2,
      headerClassName: "bg-customBlue text-white rounded-tr-xl",
    },
  ];

  const getRows = () => {
    return accountDetails.map((item) => ({
      AccountNo: item.AccountNo,
      id: item.id,
      AccountName: item.AccountName,
      Status: item.status || "Unknown",
      LastUpdatedStatus: item.lastUpdated || "Unknown",
      OpenApp: item.portalUrl,
      username: item.username,
      password: item.password,
      apiUrl: item.apiUrl,
      Schedule: item.scheduledescription,
      timezone: item.timezone,
    }));
  };
  const rows = getRows();
  const paginationModel = { page: 0, pageSize: 10 };

  const handleRowSelection = (selectionModel) => {
    const selectedRowData = rows.filter((row) =>
      selectionModel.includes(row.id)
    );
    setSelectedAccounts(selectedRowData);
  };

  // const [alignment, setAlignment] = useState("enabled");

  // const handleChange = (event, newAlignment) => {
  //   setAlignment(newAlignment);
  // };

  // console.log(isEnabled);

  return (
    <Box
      sx={{
        marginLeft: "180px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 2,
        pt: 5,
        backgroundColor: "#EEEEEE",
        minHeight: "100vh",
      }}
    >
      {isAdmin || isMember ? (
        <>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ color: "#00ADB5", fontFamily: "Poppins", fontWeight: "bold" }}
          >
            Manage Accounts
          </Typography>

          <Paper
            sx={{
              height: 629,
              width: "100%",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            }}
          >
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                <CircularProgress color="primary" />
              </Box>
            ) : (
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[10, 20, 30]}
                checkboxSelection
                sx={{
                  border: 0,
                  fontFamily: "Poppins",
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#4BB543",
                  },
                  "& .MuiDataGrid-columnHeaderCheckbox": {
                    backgroundColor: "#00ADB5",
                    color: "white",
                  },
                  "&.MuiDataGrid-root": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within":
                    {
                      outline: "none",
                    },
                }}
                onRowSelectionModelChange={handleRowSelection}
              />
            )}
          </Paper>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              mt: 2,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Button
              variant="contained"
              onClick={handleStartClick}
              disabled={selectedAccounts.length === 0}
              sx={{
                backgroundColor: "#A0D683",
                color: "#FFFFFF",
                minWidth: { xs: "100px", sm: "auto" },
                fontFamily: "Poppins",
              }}
            >
              <PlayCircleFilledWhiteIcon />
              Start
            </Button>
            <Button
              variant="contained"
              onClick={handleStopClick}
              disabled={selectedAccounts.length === 0}
              sx={{
                backgroundColor: "#C62E2E",
                color: "#FFFFFF",
                minWidth: { xs: "100px", sm: "auto", fontFamily: "Poppins" },
              }}
            >
              <StopCircleIcon />
              Stop
            </Button>
            <Button
              variant="contained"
              onClick={handleStatus}
              sx={{
                backgroundColor: "#00308F",
                color: "#FFFFFF",
                minWidth: { xs: "100px", sm: "auto", fontFamily: "Poppins" },
              }}
            >
              {Statusloading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                <>
                  <UpdateIcon />
                  Refresh All
                </>
              )}
            </Button>
          </Box>
          <Dialog
            open={showChangeSchedule}
            onClose={handleCancelChange}
            PaperProps={{
              sx: {
                width: "90%",
                maxWidth: "400px",
                borderRadius: 5,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                padding: 2,
                position: "relative",
                backgroundColor: "#fff",
              }}
            >
              <Button
                sx={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  fontFamily: "Poppins",
                }}
                onClick={handleCancelChange}
              >
                <CancelIcon sx={{ color: "#00ADB5" }} />
              </Button>
              <DialogTitle
                sx={{
                  color: "#222831",
                  fontFamily: "Poppins",
                  textAlign: "center",
                }}
              >
                Modify Schedule
                <br /> ({accountDataSchedule.name})
              </DialogTitle>

              <DialogContent sx={{ padding: "0 16px", overflow: "hidden" }}>
                <DialogContentText
                  sx={{
                    color: "#222831",
                    fontFamily: "Poppins",
                    textAlign: "center",
                    marginBottom: 2,
                  }}
                >
                  Please proceed with caution when modifying the schedule. All
                  changes will be logged.
                </DialogContentText>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <FormGroup
                    sx={{ justifyContent: "center", alignItems: "center" }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ alignItems: "center" }}
                    >
                      <Typography>Disable</Typography>
                      <AntSwitch
                        // defaultChecked
                        checked={isEnabled}
                        onChange={handleToggle}
                        inputProps={{ "aria-label": "ant design" }}
                      />
                      <Typography>Enable</Typography>
                    </Stack>
                  </FormGroup>
                  {isEnabled ? (
                    <Box
                      sx={{
                        padding: 2,
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                      }}
                    >
                      <label style={{ fontFamily: "Poppins" }}>
                        Select Days
                      </label>
                      <Select
                        multiple
                        required
                        value={days || []}
                        onChange={(e) => {
                          setDays(e.target.value);
                        }}
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                            }}
                          >
                            {selected.map((value) => (
                              <Chip key={value} label={dayLabels[value]} />
                            ))}
                          </Box>
                        )}
                        fullWidth
                      >
                        <MenuItem value="2">Monday</MenuItem>
                        <MenuItem value="3">Tuesday</MenuItem>
                        <MenuItem value="4">Wednesday</MenuItem>
                        <MenuItem value="5">Thursday</MenuItem>
                        <MenuItem value="6">Friday</MenuItem>
                        <MenuItem value="7">Saturday</MenuItem>
                        <MenuItem value="1">Sunday</MenuItem>
                      </Select>
                      <FormControlLabel
                        sx={{
                          fontFamily: "Poppins",
                          "& .MuiFormControlLabel-label": {
                            fontSize: "12px",
                          },
                        }}
                        label="Servers stop on weekends. Override?"
                        control={
                          <Checkbox
                            checked={isWeekendRunEnabled}
                            onChange={handleCheckboxChange}
                          />
                        }
                      />
                      <br />
                      <label
                        style={{ fontFamily: "Poppins", marginTop: "16px" }}
                      >
                        Time Zone
                      </label>
                      <Select
                        required
                        value={zone}
                        onChange={(e) => {
                          setZone(e.target.value);
                        }}
                        renderValue={() => {
                          return zone;
                        }}
                        fullWidth
                      >
                        <MenuItem value="Asia/Calcutta">Asia/Calcutta</MenuItem>
                        <MenuItem value="Etc/GMT-4">Etc/GMT-4</MenuItem>
                      </Select>
                      <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                        <Box sx={{ flex: 1 }}>
                          <label style={{ fontFamily: "Poppins" }}>
                            Start Time{" "}
                          </label>
                          <TextField
                            required
                            type="time"
                            value={startTime || ""}
                            onChange={(e) => {
                              setStartTime(e.target.value);
                            }}
                            fullWidth
                          />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <label style={{ fontFamily: "Poppins" }}>
                            End Time{" "}
                          </label>
                          <TextField
                            required
                            type="time"
                            value={endTime || ""}
                            onChange={(e) => {
                              setEndTime(e.target.value);
                            }}
                            fullWidth
                          />
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <></>
                  )}
                </Box>
              </DialogContent>
              <DialogActions
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "8px 16px",
                }}
              >
                <Button
                  sx={{
                    fontFamily: "Poppins",
                    width: "100%",
                    color: "#00ADB5",
                    backgroundColor: "transparent",
                    "&:hover": {
                      backgroundColor: "#00ADB5",
                      color: "white",
                    },
                  }}
                  onClick={handleChangeScheduleConfirm}
                  disabled={
                    isEnabled
                      ? !days.length || !startTime || !endTime || !zone
                      : false
                  }
                >
                  Save
                </Button>
              </DialogActions>
            </Box>
          </Dialog>

          <Dialog open={showStartConfirm} onClose={handleCancel}>
            <DialogTitle sx={{ color: "#222831", fontFamily: "Poppins" }}>
              Start Confirmation
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                sx={{ color: "#222831", fontFamily: "Poppins" }}
              >
                Starting up will take about 20 minutes. Proceed?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button sx={{ fontFamily: "Poppins" }} onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                sx={{ fontFamily: "Poppins" }}
                onClick={handleStartConfirm}
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={showStopConfirm} onClose={handleCancel}>
            <DialogTitle sx={{ color: "#222831", fontFamily: "Poppins" }}>
              Stop Confirmation
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                sx={{ color: "#222831", fontFamily: "Poppins" }}
              >
                Are you sure you want to stop ECS and RDS services?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button sx={{ fontFamily: "Poppins" }} onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                sx={{ fontFamily: "Poppins" }}
                onClick={handleStopConfirm}
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <Typography
          variant="h5"
          textAlign="center"
          sx={{ color: "#0000FF", fontFamily: "Poppins" }}
        >
          You are not assigned any role. Wait for admin to provide access
        </Typography>
      )}
      <Snackbar
        sx={{ fontFamily: "Poppins" }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={!error ? "success" : "error"}>
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
